import Region from '@/creditflowresearch/domain/Region';
import { EmergingMarket } from '@/creditflowresearch/domain/Market';
import { EM_FILTER_REGION_IDS } from '@/creditflowresearch/application/PageFilters/constants';

export const checkAccessByMarket = (
  marketIdsFromQuery: string[],
  regionIdsFromQuery: string[],
  accessibleRegionIds: string[],
): boolean => {
  const currentMarketIds = marketIdsFromQuery.length > 0
    ? marketIdsFromQuery
    : Region.getMarketsByRegions(regionIdsFromQuery).map((market) => market.getId());

  const accessibleMarketIds = Region.getMarketsByRegions(accessibleRegionIds).map((market) => market.getId());

  if (currentMarketIds.length === 0 || accessibleMarketIds.length === 0) {
    return false;
  }

  const accessibleMarketSet = new Set(accessibleMarketIds);

  return currentMarketIds.some((marketId) => {
    if (marketId === EmergingMarket.MARKET_ID) {
      return accessibleRegionIds.some((regionId) => EM_FILTER_REGION_IDS.includes(regionId));
    }
    return accessibleMarketSet.has(marketId);
  });
};
